module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-type-product product-pane row row-reverse"
  }, [_c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row row-reverse product-content-row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-7"
  }, [_c('div', {
    staticClass: "product-header text-center"
  }, [_c('div', {
    staticClass: "product-slogan"
  }, [_vm._v(_vm._s(_vm.product.slogan))]), _c('h1', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.product.title))]), (_vm.product.rating) ? _c('div', {
    staticClass: "product-rating"
  }, [_c('span', {
    staticClass: "product-score"
  }, [_vm._v(_vm._s(_vm.product.rating))]), _vm._v("/5")]) : _vm._e(), (_vm.reviewArticleNode) ? _c('a', {
    staticClass: "product-review-btn hidden-xs-down",
    attrs: {
      "href": _vm.reviewArticleNode.relative_url
    }
  }, [_vm._v("read our review")]) : _vm._e()])]), _c('div', {
    staticClass: "col-12 col-sm-5 text-center image-holder-wrapper"
  }, [_c('div', {
    directives: [{
      name: "image-orientation",
      rawName: "v-image-orientation",
      value: ('wrapper'),
      expression: "'wrapper'"
    }],
    staticClass: "image-holder"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.image),
      expression: "image"
    }],
    staticClass: "product-image",
    attrs: {
      "alt": _vm.product.product.title
    }
  })]), (_vm.reviewArticleNode) ? _c('a', {
    staticClass: "product-review-btn hidden-sm-up",
    attrs: {
      "href": _vm.reviewArticleNode.relative_url
    }
  }, [_vm._v("read our review")]) : _vm._e()])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "product-description",
    domProps: {
      "innerHTML": _vm._s(_vm.product.body)
    }
  })])])]), _c('div', {
    staticClass: "col-sm-4 col-12"
  }, [(_vm.properties) ? _c('specification-pane', {
    attrs: {
      "properties": _vm.properties
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c197b97","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/ProductPane.vue
// module id = 1746
// module chunks = 25